import React from 'react';

const ActivityItem = ({ icon, iconBg, title, description, badge, badgeColor }) => {
  return (
    <div className="flex items-start">
      <div className={`${iconBg} p-2 rounded-lg mr-4`}>
        <i className={`${icon}`}></i>
      </div>
      <div className="flex-1">
        <p className="text-sm font-medium">{title}</p>
        <p className="text-xs text-gray-500">{description}</p>
      </div>
      {badge && (
        <span className={`${badgeColor} text-xs px-2 py-1 rounded-full`}>
          {badge}
        </span>
      )}
    </div>
  );
};

export default ActivityItem;